import { render } from "./App.vue?vue&type=template&id=17d6f0af"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=17d6f0af&lang=scss"

import exportComponent from "/home/runner/work/personal-website/personal-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__